import { Link } from 'react-router-dom';

const SOC_BADGE = "https://customer-assets.emergentagent.com/job_conversion-v2/artifacts/fzozi6tn_68921b0596e50542222fc212_AD_4nXdSpDLxoWl1fEvQmLsydLibTqAy9na9E_hhh5wCwMQipmDoWrM5NWSSKB132wRlVO9R5BAemOg5eMVsYoaB9s6sMVWQLILlYcuncoydZu9npzwRwBJKxXtKxyTHANLfR5nz3cxkrQ.png";
const GDPR_BADGE = "https://customer-assets.emergentagent.com/job_conversion-v2/artifacts/lgn5ivg5_gdpr_compliant-1024x429.png";

const Footer = () => {
  return (
    <footer className="bg-[#0a0a0f] border-t border-slate-800" data-testid="global-footer">
      {/* Top accent line */}
      <div className="h-px bg-gradient-to-r from-transparent via-blue-600/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Main footer content */}
        <div className="flex flex-col lg:flex-row items-start justify-between gap-10 py-16 sm:py-20">
          {/* Left: Branding */}
          <div className="max-w-sm">
            <h3 className="font-heading text-2xl font-bold text-white mb-4">
              Plouton AI
            </h3>
            <p className="text-sm text-slate-500 leading-relaxed">
              Autonomous finance workers for companies operating at scale.
            </p>
          </div>

          {/* Right: Compliance badges */}
          <div className="flex items-center gap-4">
            <img
              src={SOC_BADGE}
              alt="AICPA SOC 2 Type II Certification Badge"
              className="h-14 w-auto object-contain opacity-50"
              width={98}
              height={98}
              loading="lazy"
            />
            <img
              src={GDPR_BADGE}
              alt="GDPR Compliant Data Protection Badge"
              className="h-14 w-auto object-contain opacity-50"
              width={234}
              height={98}
              loading="lazy"
            />
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-slate-800" />

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-8">
          <span className="text-xs text-slate-600">
            © 2026 Plouton Technology Labs, PTE. LTD.
          </span>

          <div className="flex items-center gap-6">
            <Link to="/legal#privacy" className="text-xs text-slate-500 hover:text-slate-300 transition-colors">
              Privacy
            </Link>
            <Link to="/legal#terms" className="text-xs text-slate-500 hover:text-slate-300 transition-colors">
              Terms
            </Link>
            <Link to="/legal#security" className="text-xs text-slate-500 hover:text-slate-300 transition-colors">
              Security
            </Link>
          </div>

          <div className="flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
            </span>
            <span className="text-xs text-slate-500">All systems operational</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
